// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1DCDO","errorLogs":"styles_errorLogs__2zMer"};